import { css } from 'styled-components';
/**
 * Hide the content to which this is applied visually, but not from screen
 * readers.
 */

export var visuallyHidden = css(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n"]);